import { render, staticRenderFns } from "./StudentScholarshipNotEligible.vue?vue&type=template&id=102ea2f0&scoped=true"
import script from "./StudentScholarshipNotEligible.vue?vue&type=script&lang=js"
export * from "./StudentScholarshipNotEligible.vue?vue&type=script&lang=js"
import style0 from "./StudentScholarshipNotEligible.vue?vue&type=style&index=0&id=102ea2f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "102ea2f0",
  null
  
)

export default component.exports